import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/search/decorators", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/search/decorators", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAvailable(requestOptions) {
  return __request__("GET", "/search/decorators/available", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(decoratorId, JSONbody, requestOptions) {
  return __request__("PUT", `/search/decorators/${decoratorId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(decoratorId, requestOptions) {
  return __request__("DELETE", `/search/decorators/${decoratorId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
